// API utility functions

// Get backend URL
export const getBackendUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || '';
};

// Get API base URL
export const getApiUrl = () => {
  return `${getBackendUrl()}/api`;
};

// Helper to get full image URL from relative path
export const getImageUrl = (url) => {
  if (!url) return null;
  // If it's already a full URL, return as is
  if (url.startsWith('http')) return url;
  // If it's a relative URL, prepend backend URL
  return `${getBackendUrl()}${url}`;
};

// Export constants for backward compatibility
export const BACKEND_URL = getBackendUrl();
export const API = getApiUrl();
